<div
  *appLet="{
    countdown: countdown$ | async,
    copy: appCmsCopy$ | async,
  } as $comp"
>
  <div class="modal-header">
    <button
      id="btnClose"
      type="button"
      class="btn-close close p-3"
      aria-label="Close"
      (click)="expired || $comp.countdown === null ? acceptFate() : bsModalRef.hide()"
    >
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
    <h4 class="section-title modal-title float-start">
      {{
        expired || $comp.countdown === null
          ? $comp.copy?.tokenHasExpiredTitleCopy
          : $comp.copy?.tokenWillExpireTitleCopy
      }}
    </h4>
  </div>

  <div class="modal-body">
    <div class="row">
      @if (!expired && $comp.countdown) {
        <div class="col col-12">
          {{ $comp.copy?.tokenWillExpireCopyBegin }}
          {{ $comp.countdown.minutes.toFixed(0) }} {{ $comp.copy?.minutesCopy }}
          {{ $comp.countdown.seconds.toFixed(0) }} {{ $comp.copy?.secondsCopy }}
          {{ $comp.copy?.tokenWillExpireCopyEnd }}
        </div>
      }
      @else {
        <div class="col col-12">
          {{ $comp.copy?.tokenHasExpiredCopy }}
        </div>
      }
    </div>
  </div>
  <div class="modal-footer">
    @if(!expired && $comp.countdown) {
      <div class="row align-items-center">
        <div class="col col-6">
          <button class="btn btn-primary" (click)="extendSession()">
            {{ $comp.copy?.yesCopy }}
          </button>
        </div>
        <div class="col col-6">
          <button class="btn btn-primary-outline" (click)="endSession()">
            {{ $comp.copy?.noCopy }}
          </button>
        </div>
      </div>
    } @else {
      <div class="row">
        <div class="col col-12">
          <button class="btn btn-primary" (click)="acceptFate()">
            {{ $comp.copy?.okayCopy }}
          </button>
        </div>
      </div>
    }
  </div>
</div>
